import { render } from "./addCommunication.vue?vue&type=template&id=7d4c20e0&scoped=true"
import script from "./addCommunication.vue?vue&type=script&lang=js"
export * from "./addCommunication.vue?vue&type=script&lang=js"

import "./addCommunication.vue?vue&type=style&index=0&id=7d4c20e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4c20e0"]])

export default __exports__